import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20dark%20background%20with%20warm%20golden%20and%20amber%20light%20rays%20streaming%20through%20dark%20smoky%20atmosphere%2C%20deep%20rich%20black%20base%20color%2C%20subtle%20orange%20and%20copper%20glow%20highlights%2C%20luxurious%20elegant%20mood%2C%20no%20visible%20objects%20or%20screens%2C%20abstract%20light%20texture%2C%20dramatic%20lighting%20composition%2C%20high%20detail%2C%208K%20quality&width=1800&height=900&seq=hero-bg-mango&orientation=landscape"
        alt="芒果视频 - 1080P超清画质在线观影平台"
        title="芒果视频高清在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="absolute inset-0 flex items-center justify-center z-10">
        <div className="w-full text-center px-4 md:px-6">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-4 tracking-wide drop-shadow-lg">
            {heroData.title}
          </h1>
          <p className="text-lg md:text-2xl text-background-100 mb-2 font-light drop-shadow-md">
            {heroData.subtitle}
          </p>
          <p className="text-sm md:text-base text-background-200 max-w-2xl mx-auto mb-8 drop-shadow">
            {heroData.description}
          </p>
          <div className="flex items-center justify-center gap-4 flex-col sm:flex-row">
            <Link
              to={heroData.ctaLink}
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer shadow-lg shadow-primary-500/30"
            >
              <i className="ri-play-circle-line text-lg"></i>
              {heroData.ctaText}
            </Link>
            <Link
              to={heroData.secondaryLink}
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 rounded-full border border-background-200/60 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/15 transition-all duration-200 cursor-pointer backdrop-blur-sm"
            >
              {heroData.secondaryText}
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-1 text-background-200/70 text-xs z-10">
        <span>向下滚动探索更多</span>
        <i className="ri-arrow-down-s-line"></i>
      </div>
    </section>
  );
}